export function calculateSum(props, tableData) {
  let totalSum = 0;
  let quantityField = props?.schemaPageFields?.find(
    (x) => x.catalogueSchemaType === 16 || x.schemaType === 16
  )?.fieldName;

  if (tableData) {
    totalSum = tableData
      .filter((x) => x[quantityField] > 0)
      .map((x) => parseInt(x[quantityField]))
      .reduce((a, b) => a + b, 0);
    return totalSum;
  }
}
export function calculateInputSum(props, tableData) {
  let totalSum = 0;
  let quantityField = props?.schemaPageFields?.find(
    (x) => x.catalogueSchemaType === 16 || x.schemaType === 16
  )?.tagName;


  if (tableData) {
    totalSum = tableData
      .filter((x) => x["INQ" + quantityField] > 0)
      .map((x) => parseInt(x["INQ" + quantityField]))
      .reduce((a, b) => a + b, 0);
    return totalSum;
  }
}
